// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpreadSheetComponent-titleBg-gRDoO {
    background-color: var(--common-gray-bg-color);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    padding: 16px;
    border: 1px solid var(--primary-border);
    border-bottom: 0px !important;
    position: sticky;
    top: 0;
    z-index: 1;
}

.SpreadSheetComponent-languageTitle-jWDXQ {
    margin: 0px;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
}

.SpreadSheetComponent-titleBgSection-CitF1 {
    border: 1px solid var(--primary-border);
    border-bottom-left-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
    overflow: auto;
}

.SpreadSheetComponent-exportSelect-Mg_Go {
    width: auto;
    max-width: 180px;
}

@media screen and (max-width: 767px) {
    .SpreadSheetComponent-titleBg-gRDoO {
        z-index: 2;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/SpreadSheetComponent/SpreadSheetComponent.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;IAC7C,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,uCAAuC;IACvC,6BAA6B;IAC7B,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;IACzC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".titleBg {\n    background-color: var(--common-gray-bg-color);\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n    padding: 16px;\n    border: 1px solid var(--primary-border);\n    border-bottom: 0px !important;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.languageTitle {\n    margin: 0px;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 25px;\n}\n\n.titleBgSection {\n    border: 1px solid var(--primary-border);\n    border-bottom-left-radius: 6px !important;\n    border-bottom-right-radius: 6px !important;\n    overflow: auto;\n}\n\n.exportSelect {\n    width: auto;\n    max-width: 180px;\n}\n\n@media screen and (max-width: 767px) {\n    .titleBg {\n        z-index: 2;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleBg": `SpreadSheetComponent-titleBg-gRDoO`,
	"languageTitle": `SpreadSheetComponent-languageTitle-jWDXQ`,
	"titleBgSection": `SpreadSheetComponent-titleBgSection-CitF1`,
	"exportSelect": `SpreadSheetComponent-exportSelect-Mg_Go`
};
module.exports = ___CSS_LOADER_EXPORT___;
